import { CurrencyPipe } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-aviso-form',
  templateUrl: './aviso-form.component.html',
  styleUrls: ['./aviso-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AvisoFormComponent {

  public title: string;

  //administration
  permiteEstoque: boolean = false;   

  aviso: string;
  arrayMessage: any[];
  msgEstoque: string;
  closed: boolean = false;
  alignButton: boolean = false;

  constructor(     
    public dialogRef: MatDialogRef<AvisoFormComponent>,
    private currencyPipe: CurrencyPipe,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: UntypedFormBuilder
     ){ 
      
      this.title = _data.title;
      this.aviso = _data.aviso;
      this.arrayMessage = _data.arrayMessage;      
      this.permiteEstoque = _data.permiteEstoque;
      this.msgEstoque = _data.msgEstoque;    
      this.closed = _data.closed || false;  
      this.alignButton = _data?.alignButton || false;
     }
    
     comfirm(){      
      this.dialogRef.close('Confirm');
     } 

     formatMoney(value) {
      if(!isNaN(value)){
        const temp = `${value}`.replace(/\,/g, "");
        this.currencyPipe = new CurrencyPipe('pt-BR');
        return this.currencyPipe.transform(temp, 'BRL');//.replace("$", "");
      }
      return value;
      
    }

}
